import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { SiteDto, ClientDto, ProjectDto } from '../../api/ClientApi';
import { RootState } from '../reducers';
import { myAssert } from '../../common/console';
import { WarehouseClient } from '../../api/Extensions';
import { addClientToRedux } from './clientActions';
import { GraphClient } from '../../api/MSGraphExtensions';
import { GraphUserDto } from '../../api/msGraphApi';
import { KeyRolePair } from '../../api/RoleManagement';

export const createNewEmptyProject = createAction('project/createNewEmptyProject');
export const updateProjectName = createAction<string>('project/updateProjectName');
export const selectClient = createAction<number>('project/selectClient');
export const updateProjectProjectManagers = createAction<string>('project/updateProjectProjectManagers');

export const clearProject = createAction('project/clearProject');

export const updateReduxProject = createAsyncThunk<ProjectDto, number>(
    'project/updateReduxProject',
    async (payload, thunkAPI) => {
        const projId = payload;
        return WarehouseClient.getProjectById(projId, true, true, true);
    },
);

export const saveProject = createAsyncThunk<ProjectDto, void>('project/saveProject', async (payload, thunkAPI) => {
    const rootState = thunkAPI.getState() as RootState;

    const project = rootState.projectForm.project;
    const projectId = project?.id;

    myAssert(() => project !== null);

    if (project === null) {
        throw new Error();
    }

    let savedProject: SiteDto | undefined;

    if (!!projectId && projectId !== 0) {
        const tempProject = new ProjectDto(project);

        myAssert(() => tempProject.id !== undefined);

        if (tempProject.id === undefined) {
            throw new Error();
        }

        const projectPromise = WarehouseClient.updateProject(tempProject.id, tempProject as ProjectDto);

        savedProject = await projectPromise;
    } else {
        const newProj = new ProjectDto();
        newProj.init(project);

        const projectPromise = WarehouseClient.addNewProject(newProj);

        savedProject = await projectPromise;
    }

    return savedProject;
});

export const importProjectForProjectForm = createAsyncThunk<ProjectDto, number>(
    'project/importProjectForProjectForm',
    async (payload, thunkAPI) => {
        return WarehouseClient.getProjectById(payload, true, false, false);
    },
);

export const importProjects = createAsyncThunk<ProjectDto[]>('project/importProjects', async (payload, thunkAPI) => {
    return WarehouseClient.getAllProjects(true, true, true);
});

export const importAllProjectManagers = createAsyncThunk<GraphUserDto[], void>(
    'project/importAllProjectManagers',
    async (payload, thunkAPI) => {
        const PMsPromise = GraphClient.getAllUsers().then(async (res) => {
            let filteredPMs: GraphUserDto[] = [];
            const filteredPMsPromise: Promise<GraphUserDto | undefined>[] = [];

            res.map((u) => {
                const PMPromise = GraphClient.getUserAppRoles(u.id ?? '').then((roles) => {
                    if (!!roles.find((role) => role.appRoleId === KeyRolePair.ProjectManager)) {
                        return u;
                    }
                });

                filteredPMsPromise.push(PMPromise);
            });

            const savedItems = await Promise.all(filteredPMsPromise);

            filteredPMs = savedItems.map((item) => item ?? []).flat();

            return filteredPMs;
        });

        const allPMs = await PMsPromise;

        return allPMs;
    },
);
